import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
// tslint:disable-next-line:no-unused-variable
import { Translate, translate } from 'react-jhipster';

import { IRootState } from 'app/shared/reducers';
import { createEntity, getEntity, getLatestEntity, updateEntity } from './certification.reducer';
// tslint:disable-next-line:no-unused-variable
import { PageHeaderWrapper } from '@ant-design/pro-layout';
import { Button, Card, Descriptions, Divider, Icon, Skeleton, Spin, Modal, Empty } from 'antd';
import LinkButton from 'app/shared/components/link-button';
import { detailsToEdit } from 'app/shared/util/url-utils';
import { getUser } from 'app/modules/administration/user-management/user-management.reducer';
import Meta from 'antd/lib/card/Meta';
import { defaultValue } from 'app/shared/model/certification.model';

export interface ICertificationDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ login: string }> {}
// state类型
export interface ICertificationDetailState {
  localPreviewFiles: any[];
  previewVisible: boolean;
  imgUrl: string;
}

export class CertificationDetail extends React.Component<ICertificationDetailProps, ICertificationDetailState> {
  state: ICertificationDetailState = {
    localPreviewFiles: [],
    previewVisible: false,
    imgUrl: ''
  };
  // 初始化
  componentWillMount() {
    this.props.getUser(this.props.match.params.login);
    const result = this.props.getLatestEntity(this.props.match.params.login) as any;
  }
  // 渲染btn
  action() {
    const { certificationEntity, match, loading } = this.props;
    return loading ? null : (
      <Button.Group>
        <LinkButton type={'primary'} htmlType={'button'} to={`${match.url}/edit`}>
          <Icon type={'edit'} /> <Translate contentKey="lehomeApp.certification.home.editLabel">Edit</Translate>
        </LinkButton>
      </Button.Group>
    );
  }
  // 预览
  handlePreview = async file => {
    this.setState({
      imgUrl: file,
      previewVisible: true
    });
  };
  // 上传
  renderUpload = key => {
    const imgUrl = this.props.certificationEntity && this.props.certificationEntity[key] ? this.props.certificationEntity[key] : '';
    const __onClick = () => this.handlePreview(imgUrl);
    return imgUrl !== '' ? (
      <div onClick={__onClick} style={{ width: 337, maxHeight: 213, overflow: 'hidden', display: 'relative' }}>
        <img alt="example" src={imgUrl} style={{ width: '100%' }} />
      </div>
    ) : (
      <Empty>No</Empty>
    );
  };
  // 渲染
  render() {
    const { certificationEntity, loading, user } = this.props;
    const styleProps = data => {
      if (data && data === '') {
        return { style: { width: 337 } };
      } else {
        return {};
      }
    };
    return (
      <PageHeaderWrapper
        extra={this.action()}
        title={
          user.name
            ? translate('lehomeApp.certification.home.paramsTitle', { name: user.name })
            : translate('lehomeApp.certification.home.title')
        }
      >
        <Spin size={'large'} spinning={this.props.loading}>
          <Card bordered={false}>
            <Descriptions
              title={
                <div>
                  <Divider orientation="left">
                    <Icon type="idcard" />
                    &nbsp;
                    {translate('lehomeApp.certification.tips.idCard')}
                  </Divider>
                </div>
              }
            >
              <Descriptions.Item>
                <Card hoverable {...styleProps('d')} cover={this.renderUpload('idCardFronted')}>
                  <Meta title={translate('lehomeApp.certification.help.idCardFronted')} />
                </Card>
              </Descriptions.Item>
              <Descriptions.Item>
                <Card
                  hoverable
                  cover={
                    <Skeleton loading={false} avatar active>
                      {this.renderUpload('idCardBackend')}
                    </Skeleton>
                  }
                >
                  <Meta title={translate('lehomeApp.certification.help.idCardBackend')} />
                </Card>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              title={
                <Divider orientation="left">
                  <Icon type="home" />
                  &nbsp;
                  {translate('lehomeApp.certification.tips.house')}
                </Divider>
              }
            >
              <Descriptions.Item>
                <Card hoverable cover={this.renderUpload('noHouseCert')}>
                  <Meta title={translate('lehomeApp.certification.help.noHouseCert')} />
                </Card>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              title={
                <Divider orientation="left">
                  <Icon type="insurance" />
                  &nbsp;
                  {translate('lehomeApp.certification.tips.social')}
                </Divider>
              }
            >
              <Descriptions.Item>
                <Card hoverable cover={this.renderUpload('socialInsurance')}>
                  <Meta title={translate('lehomeApp.certification.help.socialInsurance')} />
                </Card>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              title={
                <Divider orientation="left">
                  <Icon type="reconciliation" />
                  &nbsp;
                  {translate('lehomeApp.certification.tips.education')}
                </Divider>
              }
            >
              <Descriptions.Item>
                <Card hoverable cover={this.renderUpload('education')}>
                  <Meta title={translate('lehomeApp.certification.help.education')} />
                </Card>
              </Descriptions.Item>
            </Descriptions>
          </Card>
          <Modal visible={this.state.previewVisible} footer={null} onCancel={this.handleCancel}>
            <img alt="example" style={{ width: '100%' }} src={this.state.imgUrl} />
          </Modal>
        </Spin>
      </PageHeaderWrapper>
    );
  }

  handleCancel = () => {
    this.setState({
      previewVisible: false,
      imgUrl: ''
    });
  };
}

const mapStateToProps = ({ certification, userManagement }: IRootState) => ({
  certificationEntity: certification.entity,
  user: userManagement.user,
  loading: certification.loading,
  updating: certification.updating
});

const mapDispatchToProps = { getEntity, getUser, getLatestEntity, createEntity, updateEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CertificationDetail);
